export default "__VITE_ASSET__b13deee4__"